// extracted by mini-css-extract-plugin
module.exports = {"modal_body":"BasicModal_modal_body__3viGF","close_icon":"BasicModal_close_icon__8AEw2"};